import { render, staticRenderFns } from "./authstart.vue?vue&type=template&id=547c0d12&scoped=true"
import script from "./authstart.vue?vue&type=script&lang=js"
export * from "./authstart.vue?vue&type=script&lang=js"
import style0 from "./authstart.vue?vue&type=style&index=0&id=547c0d12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547c0d12",
  null
  
)

export default component.exports